// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { qtyFieldStyles } from "@eisinc/App/Components/Qty/QtyField";
import cartLineSharedStyles from "@eisinc/App/SharedStyles/CartLineSharedStyles";
import { sizeVariantValues } from "@eisinc/MobiusOverrides/FormField/formStyles";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

qtyFieldStyles.wrapper = {
    css: css`
        display: flex;
        width: 100%;
        position: relative;
        border: 1px solid ${color("common.ui5")};
        height: ${sizeVariantValues.small.height}px;
        max-width: 94px;
        background-color: ${color("common.white")};
        ${({ showActionButton }: any) =>
            !showActionButton &&
            css`
                max-width: 36px;
            `}

        &:not([class^="FormFieldLabel"]) {
            border: 1px solid ${color("common.ui5")};
        }
        &:has(input:disabled) {
            cursor: not-allowed;
            opacity: 0.33;
        }

        /* Hover/Focus behavior aligned with TextField */
        &:has(input:focus):not(:has(input:disabled)) {
            border-color: ${color("common.ui9")};
        }
        &:has(input:hover):not(:has(input:disabled)) {
            border-color: ${color("common.ui8")};
        }
        /* Simulated states for demos */
        &:has(input[data-test-selector="focus"]):not(:has(input:disabled)) {
            border-color: ${color("common.ui9")};
        }
        &:has(input[data-test-selector="hover"]:not(:focus)):not(:has(input:disabled)) {
            border-color: ${color("common.ui8")};
        }

        input {
            border: 0 !important;
        }
    `,
};
qtyFieldStyles.editableQuantityTextField = {
    mergeCss: true,
    backgroundColor: "transparent",
    sizeVariant: "small",
    labelProps: {
        css: css`
            display: none;
        `,
    },
    cssOverrides: {
        formField: css`
            && {
                && input:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                    &,
                    &:active,
                    &:hover,
                    &:focus {
                        outline: none;
                        border: 0;
                        &:not(:disabled) {
                            border: 0;
                        }
                    }
                }

                input {
                    box-shadow: none;
                    text-overflow: unset;
                }
            }
        `,
        formInputWrapper: css`
            &&&& {
                margin-top: 0;
            }
        `,

        inputSelect: css`
            font-size: ${fontConfig.small.size}px;
            line-height: 16px;
            text-align: center;
            padding: 0 !important;
            text-align: center;
            height: 26px;
            min-width: 36px;
            border: none !important;
            &:hover,
            &:focus {
                border: none !important;
            }
            &:disabled {
                background-color: transparent;
                color: inherit;
            }
        `,
    },
};
qtyFieldStyles.actionClickable = {
    css: css`
        background-color: ${color("common.white")};
        display: flex;
        min-width: 24px;
        align-items: center;
        height: 100%;
        justify-content: center;
        border: 0;
        transition: all 0.3s ease;
        ${IconWrapper}, svg {
            color: ${color("common.ui5")};
        }
        &:disabled {
            opacity: 0.33;
        }
        &:hover:not(:disabled) {
            transition: all 0.3s ease;
            background: ${color("common.ui8")};
            ${IconWrapper}, svg {
                color: ${color("common.white")};
            }
        }
    `,
};
qtyFieldStyles.countIcon = {
    color: "common.ui4",
    size: 13,
    mergeCss: true,
};

qtyFieldStyles.valueText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

qtyFieldStyles.qtyLabel = {
    ...cartLineSharedStyles.qtyLabel,
};
